import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";

export const ButtonsDiv = styled.div`
  display: flex;
  width: 50%;
  margin-left: 25%;
  gap: 3em;
`;

export const ContentContainer = styled.div`
  margin-top: 0.75em;
  margin-left: 5em;
  margin-right: 5em;
  text-align: center;
  justify-content: space-around;
  padding: 1em;

  > p {
    padding-left: 2.5em;
    padding-right: 2.5em;
  }

  > h2 {
    margin-bottom: 1em;
  }
`;

export const DeleteButton = styled(Button)`
  color: ${colours.elexonRed};
  background-color: transparent;
  font-weight: normal;
  text-transform: none;
  padding: 0;
  box-shadow: none;

  &:hover {
    color: ${colours.elexonRed};
    background: none;
    text-decoration: underline;
  }

  &:active {
    box-shadow: none;
  }

  &:focus {
    color: ${colours.elexonRed};
  }
`;
